// extracted by mini-css-extract-plugin
module.exports = {"content":"_10MR7ygvUpApeNS4k9rQdL"};